function isObject(v) {
  return v && typeof v === "object" && !Array.isArray(v);
}
function isLeaf(node) {
  return isObject(node) && Object.prototype.hasOwnProperty.call(node, "値");
}

const IMPORTANCE_LABEL_JA = {
  core: "コア",
  supplementary: "補助用",
  administrative: "管理用",
  コア: "コア",
  補助用: "補助用",
  管理用: "管理用",
};

function japaneseImportance(value) {
  return IMPORTANCE_LABEL_JA[value] || value;
}

export function normalizeImportanceLabels(data) {
  if (Array.isArray(data)) {
    data.forEach(normalizeImportanceLabels);
    return data;
  }
  if (!isObject(data)) return data;

  if (Object.prototype.hasOwnProperty.call(data, "重要度")) {
    data["重要度"] = japaneseImportance(data["重要度"]);
  }
  if (Object.prototype.hasOwnProperty.call(data, "importance")) {
    data.importance = japaneseImportance(data.importance);
  }

  Object.values(data).forEach(normalizeImportanceLabels);
  return data;
}

export default function applyEditsToJson(data, edits) {
  normalizeImportanceLabels(data);

  function walk(node, path = [], editPrefix = "") {
    if (!isObject(node)) return;

    if (isLeaf(node)) {
      if ("重要度" in node) node["重要度"] = japaneseImportance(node["重要度"]);
      const k = `${editPrefix}${path.join(" > ")}`;
      const edit = edits[k];
      if (edit) {
        if ("value" in edit) node["値"] = edit.value === "" ? null : edit.value;
        if ("importance" in edit) node["重要度"] = japaneseImportance(edit.importance);
      }
      return;
    }

    // The result renderer uses P{page}:: prefixes so identical field paths on
    // different pages do not overwrite each other's edits.
    if (Array.isArray(node.pages)) {
      node.pages.forEach((page) => {
        if (!isObject(page?.context)) return;
        walk(page.context, [], `P${page.page}::`);
      });
      return;
    }

    for (const key of Object.keys(node)) {
      if (key === "field_id" || key === "key_jp") continue;
      walk(node[key], [...path, key], editPrefix);
    }
  }

  walk(data, []);
  return data;
}
